/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Assign_Track_DInputs */



/**
* | output |
* | --- |
* | "Assign the selected event(s) to track D" |
*
* @param {Shortcut_Keys_Desc_Assign_Track_DInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_assign_track_d = /** @type {((inputs?: Shortcut_Keys_Desc_Assign_Track_DInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Assign_Track_DInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer le ou les événements sélectionnés au suivi D")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weisen Sie die ausgewählten Ereignisse der Spur D zu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna l'evento/gli eventi selezionati al track D")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначьте выбранное событие (события) для отслеживания D.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asigne el/los evento(s) seleccionado(s) a la pista D.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件分配给跟踪 D。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントをトラックDに割り当てます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना(ओं) को ट्रैक D में असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribua o(s) evento(s) selecionado(s) à trilha D.")
	return /** @type {LocalizedString} */ ("Assign the selected event(s) to track D")
});